import phoneDigitsMap from './phoneDigits.json';

export function digitsForCountryCode(countryCode) {
  const direct = phoneDigitsMap[countryCode];
  if (direct) return direct;
  const prefix = '+' + String(countryCode).replace(/[^0-9]/g, '').slice(0, 2);
  return phoneDigitsMap[prefix] || 9;
}

export function sanitizePhoneNumber(raw, countryCode) {
  let digits = String(raw || '').replace(/[^0-9]/g, '');
  const ccDigits = String(countryCode || '').replace(/[^0-9]/g, '');
  const expected = digitsForCountryCode(countryCode);

  if (ccDigits && digits.startsWith(ccDigits) && digits.length > expected) {
    digits = digits.slice(ccDigits.length);
  }
  if (digits.length === expected + 1 && digits.charAt(0) === '0') {
    digits = digits.slice(1);
  }
  return digits.slice(0, expected);
}
